const news = [
  { // 文章
    id: "24",
    title: "【TSK｜國際注射線上研討會-梁仲斌 醫師】",
    time: "2026/10/27",
    link: "/news/24",
    src: require("@/assets/images/news/24/news_01.jpg"),
    component: () => import("@/components/news/News24.vue"),
    video: false,
  },
  { // 文章
    id: "23",
    title: "【TSK｜國際注射線上研討會】",
    time: "2026/10/15",
    link: "/news/23",
    src: require("@/assets/images/news/23/news_01.jpg"),
    component: () => import("@/components/news/News23.vue"),
    video: false,
  },
  { // 影片
    id: "22",
    title: "【 TSK | 2026 AMWC Asia-TDAC 】",
    time: "2026/05/04",
    src: require("@/assets/images/news/22/news_01.jpg"),
    link: "https://www.youtube.com/embed/Er-XAELX0MA?si=Zosy56zwweu2ZFxp",
    video: true,
  },
  { // 文章
    id: "21",
    title: "【 TSK | AMWC Asia-TDAC 】",
    time: "2026/04/02",
    link: "/news/21",
    src: require("@/assets/images/news/21/news_01.jpg"),
    component: () => import("@/components/news/News21.vue"),
    video: false,
  },
  { // 文章
    id: "20",
    title: "【 TSK 線上研討會 】",
    time: "2026/04/02",
    link: "/news/20",
    src: require("@/assets/images/news/20/news_01.jpg"),
    component: () => import("@/components/news/News20.vue"),
    video: false,
  },
  { // 影片
    id: "19",
    title: "【 TSK | AMWC Asia-TDAC 花絮影片 】",
    time: "2025/05/07",
    src: require("@/assets/images/news/19/news_01.jpg"),
    link: "https://www.youtube.com/embed/lo-bBAmKwL8",
    video: true,
  },
  { // 文章
    id: "18",
    title: "【 TSK | AMWC Asia-TDAC 】",
    time: "2025/04/21",
    link: "/news/18",
    src: require("@/assets/images/news/18/news_01.jpg"),
    component: () => import("@/components/news/News18.vue"),
    video: false,
  },
  { // 影片
    id: "17",
    title: "【 TSK | 中華民國美容醫學醫學會 花絮影片 】",
    time: "2025/04/14",
    src: require("@/assets/images/news/17/news_01.jpg"),
    link: "https://www.youtube.com/embed/mM5-y-5n2Lg",
    video: true,
  },
  { // 文章
    id: "16",
    title: "【 TSK | 中華民國美容醫學醫學會 】",
    time: "2025/04/08",
    link: "/news/16",
    src: require("@/assets/images/news/16/news_01.jpg"),
    component: () => import("@/components/news/News16.vue"),
    video: false,
  },
  { // 影片
    id: "15",
    title: "【 TSK | 台灣醫用雷射光電學會 花絮影片 】",
    time: "2025/04/02",
    src: require("@/assets/images/news/15/news_01.jpg"),
    link: "https://www.youtube.com/embed/K9yKWwq04nU",
    video: true,
  },
  { // 文章
    id: "14",
    title: "【 TSK | 台灣醫用雷射光電學會 】",
    time: "2025/03/03",
    link: "/news/14",
    src: require("@/assets/images/news/14/news_01.jpg"),
    component: () => import("@/components/news/News14.vue"),
    video: false,
  },
  { // 文章
    id: "13",
    title: "【 TSK | 台灣微整形美容醫學會 】",
    time: "2024/12/16",
    link: "/news/13",
    src: require("@/assets/images/news/13/news_01.jpg"),
    component: () => import("@/components/news/News13.vue"),
    video: false,
  },
  { // 文章
    id: "11",
    title: "【 TSK | 臺灣整形外科醫學會年會 】",
    time: "2024/11/25",
    link: "/news/11",
    src: require("@/assets/images/news/11/news_01.jpg"),
    component: () => import("@/components/news/News11.vue"),
    video: false,
  },
  { // 文章
    id: "09",
    title: "【 TSK | TDA 臺灣皮膚科醫學會 】",
    time: "2024/11/06",
    link: "/news/09",
    src: require("@/assets/images/news/09/news_01.jpg"),
    component: () => import("@/components/news/News09.vue"),
    video: false,
  },
  { // 文章
    id: "07",
    title: "【 TSK | 臺灣醫用雷射光電學會 秋季學術研討會 】",
    time: "2024/10/16",
    link: "/news/07",
    src: require("@/assets/images/news/07/news_01.jpg"),
    component: () => import("@/components/news/News07.vue"),
    video: false,
  },
  { // 文章
    id: "05",
    title: "【 TSK | ISDS 國際皮膚外科學會 】",
    time: "2024/08/28",
    link: "/news/05",
    src: require("@/assets/images/news/05/news_01.jpg"),
    component: () => import("@/components/news/News05.vue"),
    video: false,
  },




  // { // 影片
  //   id: "00",
  //   title: "【2021 臺灣醫用雷射光電學會】",
  //   time: "2021/03/27",
  //   src: require("@/assets/images/zh-TW/news/news_2.png"),
  //   link: "https://www.youtube.com/embed/9KMuw2rDCSw",
  //   video: true,
  // },
]
export default news